import { ActionSubTypes } from '../../actions/ActionSubTypes';
import { ToastContent, ToastOptions } from 'react-toastify';
import { EnvironmentVariables } from '../EnvironmentVariables';

export interface IToastInterface {
  type: 'success' | 'warning' | 'error' | 'warn';
  message: ToastContent;
  options: ToastOptions | undefined;
}

export interface ILoginConstants {
  uid: string;
  headerLogin: {
    link: string;
  };
  sentProps: { toast: IToastInterface } | undefined;
  formLogin: {
    formHeader: { title: string; info: string };
    formFields: {
      formUsernameField: {
        name: string;
        iconclass: string;
        type: string;
        placeholder: string;
      };
      formPasswordField: {
        name: string;
        iconclass: string;
        type: string;
        placeholder: string;
      };
      formRememberMeField: {
        name: string;
        type: string;
        forgotPasswordIcon: string;
      };
    };
    formButton: {
      text: string;
    };
  };
  formKullaniciKontrol: {
    formHeader: { title: string; info: string };
    formFields: {
      formUsernameField: {
        name: string;
        iconclass: string;
        type: string;
        placeholder: string;
      };
      formPhoneNumberField: {
        name: string;
        iconclass: string;
        type: string;
        placeholder: string;
      };
    };
    formButton: {
      text: string;
    };
  };
  formOtpKontrol: {
    formHeader: { title: string; info: string };
    formFields: {
      formOtpField: {
        name: string;
        iconclass: string;
        type: string;
        placeholder: string;
      };
    };
    formButton: {
      text: string;
    };
  };
  formSifreDegistir: {
    formHeader: { title: string; info: string };
    formFields: {
      formNewPasswordField: {
        name: string;
        iconclass: string;
        type: string;
        placeholder: string;
      };
      formNewPasswordConfirmField: {
        name: string;
        iconclass: string;
        type: string;
        placeholder: string;
      };
    };
    formButton: {
      text: string;
    };
  };
}

export const LoginConstants: ILoginConstants = {
  uid: ActionSubTypes.PAGE_LOGIN,
  headerLogin: {
    link: EnvironmentVariables.OyakLogoSvg,
  },
  sentProps: undefined,
  formLogin: {
    formHeader: { title: 'Hoşgeldiniz', info: 'Giriş yapın' },
    formFields: {
      formUsernameField: {
        name: 'username',
        iconclass: 'icon-username',
        type: 'text',
        placeholder: 'Kullanıcı adınız',
      },
      formPasswordField: {
        name: 'password',
        iconclass: 'icon-password',
        type: 'password',
        placeholder: 'Şifreniz',
      },
      formRememberMeField: {
        name: 'rememberme',
        type: 'checkbox',
        forgotPasswordIcon: 'icon-question',
      },
    },
    formButton: {
      text: 'Giriş',
    },
  },
  formKullaniciKontrol: {
    formHeader: {
      title: 'Şifremi Unuttum',
      info: 'Şifrenizi sıfırlamak için aşağıdaki bilgileri giriniz.',
    },
    formFields: {
      formUsernameField: {
        name: 'username',
        iconclass: 'icon-username',
        type: 'text',
        placeholder: 'Kullanıcı adınız',
      },
      formPhoneNumberField: {
        name: 'phoneNumber',
        iconclass: 'icon-password',
        type: 'phoneNumber',
        placeholder: 'Cep Telefonunuz',
      },
    },
    formButton: {
      text: 'Şifremi Unuttum',
    },
  },
  formOtpKontrol: {
    formHeader: {
      title: 'OTP (Tek Seferlik Şifre) Kontrolü',
      info: 'Cep telefonunuza gelen kodu giriniz.',
    },
    formFields: {
      formOtpField: {
        name: 'otp',
        iconclass: 'icon-otp',
        type: 'text',
        placeholder: '6 Haneli OTP Kodunuz',
      },
    },
    formButton: {
      text: 'Şifremi Sıfırla',
    },
  },
  formSifreDegistir: {
    formHeader: {
      title: 'Şifre Belirle',
      info: 'Yeni şifrenizi giriniz.',
    },
    formFields: {
      formNewPasswordField: {
        name: 'password',
        iconclass: 'icon-password',
        type: 'password',
        placeholder: 'Yeni şifrenizi girin',
      },
      formNewPasswordConfirmField: {
        name: 'confirmPassword',
        iconclass: 'icon-password',
        type: 'password',
        placeholder: 'Yeni şifrenizi onaylayın',
      },
    },
    formButton: {
      text: 'Şifremi değiştir',
    },
  },
};
